/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { AnalyticsService } from './@core/utils/analytics.service';
import { SeoService } from './@core/utils/seo.service';
import { ClarityService } from './@core/utils/clarity.service';
import { AmbienteDataService } from './shared/services/ambiente/ambiente-data.service';
import { AmbienteHeaderService } from './@theme/services/ambiente-header.service';
import { clienteVoltarNavegacao } from './shared/routing/cliente-voltar-reuse.strategy';

@Component({
  selector: 'ngx-app',
  template: `
    <router-outlet></router-outlet>
    <app-cookie-banner></app-cookie-banner>
  `,
})
export class AppComponent implements OnInit {

  constructor(
    private analytics: AnalyticsService,
    private seoService: SeoService,
    private clarityService: ClarityService,
    private ambienteDataService: AmbienteDataService,
    private ambienteHeaderService: AmbienteHeaderService,
    router: Router,
  ) {
    this.ambienteHeaderService.aplicar('producao');
    this.carregarAmbienteDaApi();
    router.events.subscribe(event => {
      if (!(event instanceof NavigationStart)) {
        return;
      }
      const url = event.url.split(/[?#]/)[0];
      clienteVoltarNavegacao.indoParaClienteEditar = /\/cliente\/editar$/.test(url);
    });
  }

  ngOnInit(): void {
    this.analytics.trackPageViews();
    this.seoService.trackCanonicalChanges();
  }

  private carregarAmbienteDaApi(): void {
    this.ambienteDataService.GetAmbiente().subscribe(
      value => {
        if (value?.success && value.data?.ambiente) {
          this.ambienteHeaderService.aplicar(value.data.ambiente);
        }
      },
      err => {
        console.error('Erro ao identificar o ambiente do banco da API:', err);
      }
    );
  }
}
